/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBookExchangeTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBookExchange,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Share Our Reads!",
    "Books and Friends Unite!",
    "Exchange and Explore!",
  ],
  title: "Book Exchange",
  description: "Organize a fun book exchange event.",
  longDescription:
    "Gather your friends for a delightful book exchange! Choose a date, decide on the books to bring, and plan refreshments for the event!",
  emoji: "📚",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Calendar,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Book Exchange",
          emoji: "📚",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the book exchange?",
          emoji: "📅",
          completeAction: {
            question: "Decide on books to bring?",
            description: "What books should we all bring to exchange?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What books should we exchange?",
                emoji: "📖",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we have during the exchange?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍪",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "☕",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Happy Reading!",
    outroDescription:
      "Your book exchange plans are set! Enjoy sharing and discovering new books!",
  },
};
